module.exports = __webpack_public_path__ + "img/mercedes.4df2f9de.jpg";